import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { tg } from './lib/telegram';

tg.ready();
tg.expand();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
